<template>
  <CatalogueSkeleton v-if="isLoading" type="card"/>

  <div class="catalogueError" v-else-if="isLoadFailure">
    <p>{{ $t('productCatalogue.loadError') }}</p>
    <a class="button accent" @click="$emit('retry')">
      <div class="text">{{ $t('productCatalogue.retry') }}</div>
    </a>
  </div>

  <div class="catalogueEmpty" v-else-if="!items.length">
    <p>{{ $t('productCatalogue.empty') }}</p>
  </div>

  <div class="productCards alignLeft" v-else>
    <!-- el backend ya devuelve el slug compuesto: 'herramienta-electrica/amoladoras' -->
    <LocalizedLink
        class="productCard lightBackground"
        :to="`${$t('routes.products')}/${item.slug}`"
        v-for="item in items"
        :key="item.code"
    >
      <img :src="imageUrl(item.image)" :alt="item.subcategory" :title="item.subcategory" loading="lazy">

      <div class="texts">
        <div class="title">{{ item.subcategory }}</div>
      </div>
    </LocalizedLink>
  </div>
</template>

<script>
import { computed } from 'vue'
import LocalizedLink from '@/components/LocalizedLink.vue'
import CatalogueSkeleton from '@/components/catalogue/CatalogueSkeleton.vue'
import useCatalogueImage from '@/composables/useCatalogueImage'

/**
 * Parrilla de subcategorias de la landing del catalogo.
 *
 * Reutiliza .productCard a proposito: mismo objeto visual que las tarjetas de
 * articulo, distinto contenido. Es lo que hace WorkPro y evita inventar un
 * segundo tipo de tarjeta.
 */
export default {
  name: 'CatalogueCategoriesGrid',
  components: { LocalizedLink, CatalogueSkeleton },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Object,
      default: null
    }
  },
  emits: ['retry'],
  setup(props) {
    const { imageUrl } = useCatalogueImage()

    const isLoadFailure = computed(() => {
      if (!props.error) return false

      return props.error.code === 0 || props.error.code >= 500
    })

    return { imageUrl, isLoadFailure }
  }
}
</script>
